import { z } from 'zod';

export const schemaConsolidationResponse = z
    .object({
        accessKey: z.string(),
        contractIdentifier: z.string(),
        url: z.string(),
    })
    .passthrough();

export type SchemaConsolidationResponse = z.infer<typeof schemaConsolidationResponse>;
